/*
    This file is used to track and document all of the refresh zones that can be used for ad refreshes.

    Please keep them alphabetically ordered.
 */

module.exports = {
    // ??
    ABOVE_FOLD: 'aboveFold',

    // will refresh ads when a user drags a carousel item or clicks to view the next or previous item
    CAROUSEL: 'carousel',

    // will refresh ads on relevant page clicks or when scrolling
    ENGAGEMENT: 'engagement',

    // will refresh ads when the global nav is engaged and the user is not redirected to another page
    GLOBAL_NAV: 'globalnav',

    // will refresh ads when they (re-)appear in the viewport
    VIEWPORT: 'viewport',

    // will refresh carousel ads when they (re-)appear in the viewport
    VIEWPORT_SLIDE: 'viewportslide',

    // will refresh custom ads when user begins or ends scrolling. Currently, used for adhesion ad
    USER_SCROLL: 'userScroll'

};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/refresh-zones.js
// module id = 83
// module chunks = 36